import {userConstants} from "../constants/user.constants";
import jwt from 'jwt-decode'

let user;

const authToken = localStorage.getItem('auth-token');

if(authToken) {
    user = jwt(authToken);
}

const initialState = user ? { loggedIn: true, user: user } : {};


export function authenticationReducer(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                loggingIn: true,
                user: action.user
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user
            };
        case userConstants.LOGIN_FAILURE:
            return {};
        case userConstants.LOGOUT:
            return {};
        default:
            return state
    }
}
